module.exports = __webpack_public_path__ + "static/img/attend.48ece13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/attend.png
// module id = 5MnN
// module chunks = 1